import accommodationList from './AccommodationList/it.json';
import chat from './Chat/it.json';
import common from './Common/it.json';
import consent from './Consent/it.json';
import forgotPassword from './ForgotPassword/it.json';
import main from './Main/it.json';
import signIn from './SignIn/it.json';
import signUp from './SignUp/it.json';
import transportList from './TransportList/it.json';

export default {
  accommodationList,
  chat,
  common,
  consent,
  forgotPassword,
  signIn,
  signUp,
  transportList,
  main
};
